import * as React from 'react';
import * as Moment from 'moment-timezone';
import TimeInput from './TimeInput';
import StatTable from './StatTable';

interface IAppState {
  firstDate: Date;
  firstTz: string;
  secondDate: Date;
  secondTz: string;
}

function getDateFromStorage(key: string) {
  const str = window.localStorage.getItem(key);
  if (str) {
    return Moment(Number(str)).second(0).toDate();
  }
  return null;
}

function getStringFromStorage(key: string) {
  return window.localStorage.getItem(key);
}

export default class TimeCalculator extends React.Component<{}, IAppState> {

  constructor(props: any) {
    super(props);
    const now = Moment().second(0).toDate();
    const defaultTz = "Europe/Budapest";
    this.state = {
      firstDate: getDateFromStorage("firstDate") || now,
      firstTz: getStringFromStorage("firstTz") || defaultTz,
      secondDate: getDateFromStorage("secondDate") || now,
      secondTz: getStringFromStorage("secondTz") || defaultTz
    };
    this.firstChanged = this.firstChanged.bind(this);
    this.firstTzChanged = this.firstTzChanged.bind(this);
    this.secondChanged = this.secondChanged.bind(this);
    this.secondTzChanged = this.secondTzChanged.bind(this);

  }

  public render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <TimeInput
              id="timeinput-from"
              label="Starting Date"
              value={this.state.firstDate}
              onChange={this.firstChanged}
              onTzChange={this.firstTzChanged}
              tz={this.state.firstTz}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <TimeInput
              id="timeinput-to"
              label="End Date"
              value={this.state.secondDate}
              onChange={this.secondChanged}
              onTzChange={this.secondTzChanged}
              tz={this.state.secondTz}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col" />
          <div className="col-lg-4">
            <StatTable 
              firstDate={this.state.firstDate} 
              firstTz={this.state.firstTz}
              secondDate={this.state.secondDate} 
              secondTz ={this.state.secondTz}
            />
          </div>
          <div className="col" />
        </div>
      </div>
    )
  }

  public firstChanged(date: Date) {
    this.setState({
      firstDate: date
    });
    window.localStorage.setItem("firstDate", date.getTime().toString());
  }

  public secondChanged(date: Date) {
    this.setState({
      secondDate: date
    });
    window.localStorage.setItem("secondDate", date.getTime().toString());
  }

  public firstTzChanged(tz: string) {
    this.setState({
      firstTz: tz
    });
    window.localStorage.setItem("firstTz", tz);
  }

  public secondTzChanged(tz: string) {
    this.setState({
      secondTz: tz
    });
    window.localStorage.setItem("secondTz", tz);
  }
}


// WEBPACK FOOTER //
// ./src/Calculator/TimeCalculator.tsx